var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVisibilityOff = function SvgVisibilityOff(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.9,6.9l3.5-3.5l-0.9-0.9l-3.7,3.7c-1.5-0.9-3.1-1.4-4.9-1.4c-4.3,0-8.1,2.9-9.2,7c0,0.1,0,0.2,0,0.3 c0.6,2,1.8,3.7,3.3,4.9l-3.5,3.5l0.9,0.9l3.7-3.7c1.5,0.9,3.1,1.4,4.9,1.4c4.3,0,8.1-2.9,9.2-7c0-0.1,0-0.2,0-0.3 C20.7,9.8,19.5,8.2,17.9,6.9z M4,12c1.1-3.5,4.3-5.9,8-5.9c1.4,0,2.8,0.4,4,1l-2.2,2.2c-0.5-0.3-1.1-0.5-1.7-0.5 c-1.7,0-3.1,1.4-3.1,3.1c0,0.6,0.2,1.2,0.5,1.7L7,16.2C5.6,15.1,4.5,13.7,4,12z M13.9,12c0,1-0.8,1.9-1.9,1.9 c-0.3,0-0.6-0.1-0.8-0.2l2.5-2.5C13.8,11.4,13.9,11.7,13.9,12z M10.1,12c0-1,0.8-1.9,1.9-1.9c0.3,0,0.6,0.1,0.8,0.2l-2.5,2.5 C10.2,12.6,10.1,12.3,10.1,12z M12,17.9c-1.4,0-2.8-0.4-4-1l2.2-2.2c0.5,0.3,1.1,0.5,1.7,0.5c1.7,0,3.1-1.4,3.1-3.1 c0-0.6-0.2-1.2-0.5-1.7L17,7.8c1.4,1,2.4,2.5,2.9,4.2C18.9,15.5,15.6,17.9,12,17.9z",
    fill: "none"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVisibilityOff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/VisibilityOff.574927bf.svg";